<template>
  <v-content v-if="loading">
    <!-- <v-content> -->
    <transition name="fade">
      <loading v-if="isLoading"></loading>
    </transition>
    <!-- 确认框 -->
    <confirm ref="myConfirm"
             @clickFun="doClick"></confirm>

    <!-- 提示框 -->
    <confirm ref="myAlert"></confirm>

    <v-flex class="center-style">
      <v-flex class="content">
        <v-flex class="title">{{kbn==0?'新闻修改':'新闻添加'}}</v-flex>

        <v-row>
          <v-flex>
            <v-row>
              <v-row class="title-part">
                <v-card-title class="add-title"
                              primary-title>标题:</v-card-title>
                <v-text-field class="add-field"
                              name="login"
                              type="text"
                              v-model="fromNews.newsTitle"
                              :error="error"
                              :rules="[rules.required]" />

              </v-row>
              <v-row class="date">
                <v-card-title class="add-title"
                              primary-title>时间:</v-card-title>
                <v-text-field class="date-input"
                              v-model="fromNews.createTime"
                              prepend-icon="mdi-calendar"
                              @click="dateDialog = true"
                              readonly
                              :error="error"
                              :rules="[rules.required]"></v-text-field>

                <v-date-picker class="date-picker"
                               v-show="dateDialog"
                               @change="dateDialog = false"
                               locale="zh-cn"
                               v-model="fromNews.createTime"></v-date-picker>
              </v-row>
            </v-row>

            <v-row>
              <v-card-title class="add-title"
                            primary-title>简介:</v-card-title>
              <v-textarea class="textarea-news"
                          autocomplete="简介"
                          v-model="fromNews.newsIntroduction"
                          :error="error"
                          :rules="[rules.required]"></v-textarea>
            </v-row>

            <v-row>
              <v-row class="images-part">
                <v-card-title class="add-title"
                              primary-title>照片:</v-card-title>

                <v-file-input filled
                              prepend-icon="mdi-camera"
                              @change="uploadImg"
                              accept="image/gif,image/jpeg, image/png, image/jpg"
                              :error="error"
                              :rules="[rules.required]"></v-file-input>
                <v-btn @click="previewImage = !previewImage"
                       style="height: 55px;">
                  <v-icon>{{previewImage?'fa fa-eye':'fa fa-eye-slash'}}</v-icon>
                </v-btn>
              </v-row>
              <img class="image"
                   v-show="previewImage"
                   v-if="fromNews.photo"
                   :src="fromNews.photo" />
            </v-row>

          </v-flex>

        </v-row>

        <!-- 富文本框 -->
        <v-flex class="news">
          <editor v-if="hackReset" ref="myQuillEditor"
                  :content=fromNews.newsContent></editor>
        </v-flex>

        <v-flex class="center-style"
                v-show="!addSuccess">
          <v-btn @click="click">{{kbn==0?'修改':'添加'}}</v-btn>
        </v-flex>
      </v-flex>
    </v-flex>

  </v-content>
</template>
<script>

import Loading from '@/components/core/Loading' //引入新闻列表分页 api 接口
import { EventBus } from '../backStage/bus'

export default {
  components: { Loading },
  data () {
    return {
      loading: false,
      //查看添加标识
      kbn: 0,
      //添加成功标识
      addSuccess: false,
      isLoading: false,
      newsId: 0,
      previewImage: false,

      fromNews: {
        //标题
        newsTitle: "",
        //简介
        newsIntroduction: "",
        //缩略图
        photo: "",
        //创建时间
        createTime: "",
        //新闻内容
        newsContent: "",
        //修改时间
        updateTime: ""
      },
      //是否错误
      error: false,
      //错误提醒
      rules: {
        required: (value) => !!value || '必填项，不能为空'
      },
      dateDialog: false
    }
  },
  created () {
    //this.kbn = this.$route.query.kbn;
    // ↓ 获取参数（具体是啥我也不知道）
    this.hackReset = false;
    EventBus.$on("newsType", (msg, id) => {
      this.kbn = msg;
      switch (msg) {
        case 0:
          this.getNews(id);
          this.hackReset = true;
          break;
        case 1:
          this.fromNews.newsTitle = "";
          this.fromNews.photo = "";
          this.fromNews.createTime = "";
          this.fromNews.newsContent = "";
          this.fromNews.updateTime = "";
          //this.$refs.myQuillEditor.contentText = "";
          this.fromNews.newsIntroduction = "";
          this.loading = true;
          this.hackReset = true;
          // alert("添加");
          break;
      }
      // if (msg == 0) {
      //   this.getNews(id);
      //   // console.log(msg);
      // } else {
      //   this.fromNews.newsTitle = "";
      //   this.fromNews.photo = "";
      //   this.fromNews.createTime = "";
      //   this.fromNews.newsContent = "";
      //   this.fromNews.updateTime = "";
      //   this.$refs.myQuillEditor.contentText = "";
      //   this.loading = true;
      //   this.fromNews.newsIntroduction = "";
      //   // console.log(msg);
      // }
    });
  },
  beforeDestroy(){
      EventBus.$off("newsType")
  },
  methods: {

    //初期化
    init () {
      //this.loading = true;
      //if (this.kbn == 0) {
       // this.getNews(this.$route.query.newsId);
      //} else {
       // this.loading = true;
      //}
      // let that = this;
      // EventBus.$on("newsType", function (msg) {
      //   that.kbn = msg;
      //   if (msg == 0) {
      //     that.getNews('14');
      //     // console.log(msg);
      //   } else {
      //     that.fromNews.newsTitle = "";
      //     that.fromNews.newsIntroduction = "";
      //     that.fromNews.photo = "";
      //     that.fromNews.createTime = "";
      //     that.fromNews.newsContent = "";
      //     that.fromNews.updateTime = "";
      //     that.$refs.myQuillEditor.contentText = "";
      //     that.loading = true;
      //     console.log(msg);
      //   }
      // });
    },
    getNews (id) {
      this.isLoading = true;
      this.$store
        .dispatch("GetNewsContent", id)
        .then(response => {
          this.fromNews = response.data.data;
          //this.$refs.myQuillEditor.contentText = this.fromNews.newsContent;
          this.isLoading = false;
          this.loading = true;
        })
        .catch(() => { this.isLoading = false; });

      // alert(this.$store)
    },

    //添加图片
    uploadImg (e) {
      this.imageToBase64(e, true, function (val, obj) {
        obj.photo = val;
      }, this.fromNews);
    },

    //添加新闻
    addNews () {
      this.isLoading = true;
      //新闻作者Id
      let author = sessionStorage.userId.substring(1,sessionStorage.userId.length - 1);
      this.fromNews["newsAuthor"] = author;
      //修改时间暂存token
      this.fromNews["updateTime"] = sessionStorage.token;
      this.$store.dispatch("AddNews", this.fromNews).then(response => {
        let result = response.data.data;
        let str = "";

        switch (result) {
          case 200:
            str = "添加成功!"
            break;
          case 401:
            str = "身份登陆过期，请重新登录!"
            break;
          case 500:
            str = "图片上传失败!"
            break;
          case 5001:
            str = "新闻上传失败!"
            break;
          default:
            str = "添加失败!"
        }
        this.$refs.myAlert.show(str, {
          type: 'alert'
        })
        this.addSuccess = true;
        this.isLoading = false;
        this.init();
      })
        .catch(() => {
          this.isLoading = false;
        });
    },

    //修改新闻
    updateNews () {
      this.isLoading = true;
      //修改时间暂存token
      this.fromNews["updateTime"] = sessionStorage.token;

      this.$store.dispatch("UpdateNewsContent", this.fromNews).then(response => {
        let result = response.data.data;
        let str = "";
        switch (result) {
          case 200:
            str = "修改成功!"
            break;
          case 401:
            str = "身份登陆过期，请重新登录!"
            break;
          case 500:
            str = "图片上传失败!"
            break;
          case 5001:
            str = "新闻上传失败!"
            break;
          default:
            str = "修改失败!"
        }
        this.$refs.myAlert.show(str, {
          type: 'alert'
        })
        this.isLoading = false;
        //this.init();
      })
        .catch(() => {
          this.isLoading = false;
        });
    },

    //点击“修改”或者“添加”按钮
    click () {
      this.$refs.myConfirm.show(this.kbn == 1 ? "确认添加该新闻" : "确认修改该新闻？", {})
    },

    doClick () {
      //获取新闻内容
      this.fromNews.newsContent = this.$refs.myQuillEditor.contentText;
      if (this.fromNews.newsTitle && this.fromNews.newsIntroduction && this.fromNews.photo) {
        this.kbn == 1 ? this.addNews() : this.updateNews()
      }
      else {
        this.$refs.myAlert.show("请补全内容", {
          type: 'alert'
        })
        this.error = false;
      }
    },

    /**
* 
* @param {需要转换的图片file} file 
* @param {是否返回压缩后的base64} isCompression 
* @param {需要修改的对象} obj 
* @param {转换成功后通过回调函数将结果返回} callback 
*/
    imageToBase64 (file, isCompression, callback, obj) {
      // 判断图片类型
      var isJpg = false;
      if (file) {
        if (file.type == 'image/jpeg' || file.type == 'image/png' || file.type == 'image/jpg') {
          isJpg = true;
        } else {
          isJpg = false;
        }

        // 判断图片大小
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isJpg) {
          this.$refs.myAlert.show("上传图片只能是jpg/png/jepg格式", {
            type: 'alert'
          });
        }
        if (!isLt2M) {
          this.$refs.myAlert.show("上传图片大小不能超过2M", {
            type: 'alert'
          });
        }

        // 创建一个HTML5的FileReader对象
        var reader = new FileReader()
        // 创建一个img对象
        var img = new Image()
        // let filename = file.filename
        if (file) {
          reader.readAsDataURL(file)
        }
        if (isJpg && isLt2M) {
          reader.onload = (e) => {
            // let base64Str = reader.result.split[','][1]
            img.src = e.target.result
            // base64地址图片加载完毕后执行
            img.onload = function () {
              // 缩放图片需要canvas（也可以在DOM中直接定义canvas标签，这样就能把压缩完的图片不转base64也能直接显示出来）
              var canvas = document.createElement('canvas');
              var context = canvas.getContext('2d');
              // 图片原始尺寸
              var originWidth = this.width;
              var originHeight = this.height;
              // 最大尺寸限制，可通过设置宽高来实现图片压缩程度
              var maxWidth = 580;
              var maxHeight = 326;
              // 目标尺寸
              var targetWidth = originWidth;
              var targetHeight = originHeight;
              // 图片尺寸超过最大尺寸限制
              if (originWidth > maxWidth || originHeight > maxHeight) {
                if (originWidth / originHeight > maxWidth / maxHeight) {
                  // 更改宽度，按照宽度限定尺寸
                  targetWidth = maxWidth;
                  targetHeight = Math.round(maxWidth * (originHeight / originWidth));
                } else {
                  targetHeight = maxHeight;
                  targetWidth = Math.round(maxHeight * (originWidth / originHeight));
                }
              }
              // 对图片进行缩放
              canvas.width = targetWidth;
              canvas.height = targetHeight;
              // 清除画布
              context.clearRect(0, 0, targetWidth, targetHeight)
              /** 图片压缩
               * 第一个参数是创建的img对象
               * 第二三个参数是左上角坐标
               * 后两个参数是画布区域宽高
               */
              context.drawImage(img, 0, 0, targetWidth, targetHeight)
              /** 压缩后的base64文件
               * 第一个参数可以为image/jpeg或image/webp类型的图片
               * 第二个参数设置图片质量取值0-1，超出则以默认值0.92替代
               */
              var newUrl = canvas.toDataURL('image/jpeg', 0.99)
              if (isCompression) { // 返回压缩后的base64
                callback(newUrl, obj)
              } else { // 返回不压缩的base64
                callback(e.target.result, obj)
              }
            }
          }
        }

      }
    },


  }
}
</script>

<style scoped>
.center-style {
  display: flex;
  justify-content: center;
  align-content: center;
  background: white;
}
.content {
  max-width: 1200px;
  overflow: auto;
}
.content >>> .row {
  margin: 0;
}
.title-part {
  width: 60%;
  max-width: 600px;
  margin: 0 30px 0 0;
}
.title {
  margin: 10px;
  font-size: 25px;
}
.textarea-news {
  margin: 30px;
}
.textarea-news >>> .v-text-field__slot {
  height: 100px;
  border: 2px inset rgb(240, 234, 234);
}
.date {
  position: relative;
  flex: none;
  width: 300px !important;
  margin: 0;
}
.date-picker {
  position: absolute;
  left: 100px;
  top: 50px;
  z-index: 20;
}

.images-part {
  margin: 0;
  width: 450px;
  height: 56px !important;
  flex: none;
}
.image {
  width: 290px;
  height: 163px;
  margin: 30px;
  float: left;
}

.news {
  margin: 30px;
}
</style>